import { render, staticRenderFns } from "./Foreign.vue?vue&type=template&id=2c15b5b5&scoped=true"
import script from "./Foreign.vue?vue&type=script&lang=js"
export * from "./Foreign.vue?vue&type=script&lang=js"
import style0 from "./Foreign.vue?vue&type=style&index=0&id=2c15b5b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c15b5b5",
  null
  
)

export default component.exports